<div
  (mweClickOutside)="isCalendarOpen() ? closeCalendar() : null"
  class="datepicker-container"
  [class.pseudo-focus]="isCalendarOpen()"
  [class.custom-input-invalid-state]="isDateInvalid"
>
  <span class="datepicker-input-container">
    <label [for]="id()" class="datepicker-label">{{ label() | translate }}</label>
    <input
      #inputElement
      libIKPDateInputMask
      type="text"
      maxlength="10"
      autocomplete="off"
      class="datepicker-input"
      [id]="id()"
      [placeholder]="placeholder() | translate"
      [value]="valueFormatted"
      (blur)="onTouched()"
      (input)="handleInputEvent($event)"
      [attr.data-test]="dataTest() + 'input-' + label()"
    />
  </span>
  <button
    class="btn-icon-calendar btn-clean"
    type="button"
    tabindex="-1"
    (click)="toggleCalendar()"
    [attr.data-test]="dataTest() + 'button-toggleDatepicker' + label()"
  >
    <i class="fa-solid fa-calendar-days"></i>
  </button>
  @if (this.isCalendarOpen()) {
    <div class="dropdown-container" cdkTrapFocus>
      <div class="datepicker centered-datepicker-content">
        <div class="datepicker-header bg-secondary">
          <p class="title">{{ 'invoices.filterPopup.period.datepicker.headerTitle' | translate }}</p>
          <p class="year">{{ yearHeader }}</p>
          <h2 class="fulldate">{{ dateHeader }}</h2>
        </div>
        <ngb-datepicker
          [ngModel]="value"
          [startDate]="value"
          [footerTemplate]="dpft"
          [maxDate]="maximumDate()"
          [minDate]="minimumDate()"
          (dateSelect)="handleDateSelect($event)"
        />
      </div>
    </div>
  }
</div>
<div class="invalid-feedback" [class.d-block]="isDateInvalid">{{ errorMessage | translate }}</div>
<ng-template #dpft>
  <div class="datepicker-footer">
    <mwe-button size="md" category="secondary" (click)="closeCalendar()" [attr.data-test]="dataTest() + 'button-closeDatepicker' + label()">
      {{ 'invoices.filterPopup.period.datepicker.applyDate' | translate }}
    </mwe-button>
  </div>
</ng-template>
